export default __webpack_public_path__ + "static/media/Rate_Black.b9fabb86.webp";